import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AbpHttpInterceptor } from "@api";
import { ActivityFolderClient } from "../api";
import { ReminderPoolSharedModule } from "./reminder-pool-shared.module";
import { TranslocoModule } from "@jsverse/transloco";
import { ReminderPoolComponent } from "./reminder-pool.component";
import { FolderDetailsComponent } from "./folder-details/folder-details.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatTreeModule } from "@angular/material/tree";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatToolbarModule } from "@angular/material/toolbar";
import { UiDialogModule } from "@ui/ui-dialog";
import { A11yModule } from "@angular/cdk/a11y";
import { ButtonToggleModule, FuseScrollbarModule } from "@nx-workspace/fuse";
import { DateFormFieldModule, RecurrencePickerModule, VuiModule } from "@vui";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    declarations: [ReminderPoolComponent, FolderDetailsComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ReminderPoolSharedModule,
        TranslocoModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatOptionModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSidenavModule,
        MatSortModule,
        MatTableModule,
        MatDialogModule,
        MatInputModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatToolbarModule,
        MatTreeModule,
        UiDialogModule,
        A11yModule,
        ButtonToggleModule,
        MatMenuModule,
        FuseScrollbarModule,
        VuiModule,
        DateFormFieldModule,
        RecurrencePickerModule,
    ],
    exports: [ReminderPoolComponent],
    providers: [ActivityFolderClient, { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReminderPoolModule {}
